import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { trashedPlanDirectLinkRoute } from '@atlassian/jira-router-routes-advanced-roadmaps-spa-routes/src/trashedPlanDirectLinkRoute.tsx';
import {
	TrashedPlanDirectLink,
	LazyTrashedPlanDirectLink,
} from './ui/trashed-plan-direct-link/index.tsx';

export const trashedPlanDirectLinkRouteEntry = createEntry(trashedPlanDirectLinkRoute, () => ({
	group: 'software',
	component: TrashedPlanDirectLink,
	layout: globalLayout,
	resources: [...getNavigationResources()],
	forPaint: [LazyAtlassianNavigation, LazyTrashedPlanDirectLink],
	ufoName: 'plan-trashed',
}));
